
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"24","width":"24","id":"Color-Palette-Sample-1--Streamline-Streamline--3.0.svg"}, attrs),
              ...rest,
            },
            children.concat([_c('desc',[_v('Color Palette Sample 1 Streamline Icon: https://streamlinehq.com')]),_c('defs'),_c('title',[_v('color-palette-sample-1')]),_c('path',{attrs:{"d":"M3.788 5.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0 -3 0","fill":"none","stroke":"currentcolor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M3.788 11.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0 -3 0","fill":"none","stroke":"currentcolor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M3.788 17.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0 -3 0","fill":"none","stroke":"currentcolor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M9.2 19.337a3.913 3.913 0 0 1 -7.826 0V2.707A1.957 1.957 0 0 1 3.331 0.75h3.913A1.957 1.957 0 0 1 9.2 2.707Z","fill":"none","stroke":"currentcolor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m8.643 21.352 8.349 -14.461a1.957 1.957 0 0 0 -0.716 -2.673l-3.389 -1.956A1.951 1.951 0 0 0 11.87 2","fill":"none","stroke":"currentcolor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m7.293 22.7 14.354 -8.29a1.957 1.957 0 0 0 0.716 -2.672l-1.957 -3.389a1.945 1.945 0 0 0 -0.5 -0.57","fill":"none","stroke":"currentcolor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    